import React, {useState, useMemo, useEffect} from "react";
import '../styles/pages/patrol.css';
import List from '../components/List';
import MantinePagination from '../components/MantinePagination';
import MantineDatePicker from "../components/MantineDatePicker";
import dayjs from "dayjs";
import {apiRequest} from "../utils/api";
import Button from "../components/Button";
import {useNavigate} from "react-router-dom";
import {Modal} from "@mantine/core";
import filterIcon from '../assets/icons/filter-icon.svg';

const PatrolList = () => {
    const headers = ['순찰일시', '태그NO', '현장명', '순찰자', '상태', '보기'];
    const patrolListcolumnWidths = ['20%', '25%', '20%', '10%', '12%', '8%'];
    const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [patrolList, setPatrolList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [recordDetail, setRecordDetail] = useState(null);
    const [alertOpen, setAlertOpen] = useState({isOpen: false, message: ''});
    const [allData, setAllData] = useState([]);
    const [pagedData, setPagedData] = useState([]);
    const navigate = useNavigate();
    const totalPages = Math.ceil(patrolList.length / itemsPerPage);
    const [mobileFilterModalOpen, setMobileFilterModalOpen] = useState(false);

    useEffect(() => {
        fetchPatrolList();
    }, []);

    useEffect(() => {
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        setPagedData(allData.slice(start, end));
    }, [allData, currentPage, itemsPerPage]);

    const fetchPatrolList = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user'));
        const userId = userInfo?.id;
        try {
            const res = await apiRequest('/searchRecords', 'POST', {
                startDate,
                endDate,
                userId,
            });

            const refinedData = res.data.map(user => {
                const STATE_MAP = {
                    A: '완료',
                    C: '등록',
                };

                const finalData = {}

                return {
                    REG_DTM: user.REG_DTM,
                    TAGNUM: user.TAGNUM,
                    STORE_NAME: user.STORE_NAME,
                    USER_NAME: user.USER_NAME,
                    STATE: STATE_MAP[user.STATE] || '알수없음',
                    VIEW: <Button
                        style={{background: '#F9F9F9', color: '#3d3d3d', padding: '5px 20px'}}
                        onClick={() => handleViewRecord(user)}
                    >
                        보기
                    </Button>
                };
            });

            setAllData(refinedData);
            setCurrentPage(1);
        } catch (err) {
            console.error('조회 실패:', err);
            showAlert('조회 중 오류가 발생했습니다.');
        }
    };

    const handleViewRecord = async (user) => {
        navigate('/patrolDetail', { state: { ID_HIS: user.ID_HIS } });
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const showAlert = (message) => {
        setAlertOpen({isOpen: true, message});
    };

    const handleItemsPerPageChange = (value) => {
        setItemsPerPage(parseInt(value));
        setCurrentPage(1);
    };

        const handleMobileFilterSearch = () => {
        setMobileFilterModalOpen(false);
    };

    return (
        <div className='mobile-container'>
            <div className="margin-top-section"/>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>    
    <p className='large-text gmarket-font'>순찰목록</p>                     
    <img                         
        src={filterIcon}                         
        alt="필터아이콘"                         
        className="filter-icon"                         
        onClick={() => setMobileFilterModalOpen(true)}                     
    />                     
</div>
                    <div className="top-section desktop-filter">
            <div className="date-filter-wrapper">
                <MantineDatePicker value={startDate} onChange={setStartDate}/>
                <span style={{margin: '10px 8px'}}>-</span>
                <MantineDatePicker value={endDate} onChange={setEndDate}/>
            </div>
            </div>
            <div className="margin-bottom-section"/>
            <div className="list-wrapper">
                <List headers={headers} data={pagedData} showCheckbox={false} columnWidths={patrolListcolumnWidths}/>
            </div>

            <div className='pagination-wrapper'>
                <MantinePagination
                    total={totalPages}
                    value={currentPage}
                    onChange={handlePageChange}
                />
            </div>
            <div className="margin-bottom-section"/>

{mobileFilterModalOpen && (
                <Modal
                    opened={mobileFilterModalOpen}
                    onClose={() => setMobileFilterModalOpen(false)}
                    zIndex={9999}
                    centered={false} 
                    size="md"
                    withinPortal={true} 
                    styles={{  content: { position: 'fixed',  bottom: 0,   left: 0, right: 0,  margin: 0,   borderRadius: '20px 20px 0 0', transform: 'translateY(0)',   minHeight: '50vh', maxHeight: '70vh',overflow: 'visible', animation: mobileFilterModalOpen ? 'slideUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)' : 'slideDown 0.3s ease-in' },  body: {  padding: '20px', maxHeight: '65vh', overflowY: 'auto' }, header: { display: 'none' } }} transitionProps={{  transition: 'fade', duration: 0 }} >
                    <div>
                        <div >
                           <p className='gmarket-font'>시작일</p>
                            <div>
                                <MantineDatePicker
                                    value={startDate}
                                    onChange={setStartDate}
                                    className="mobile-date-picker"
                                    comboboxProps={{
                                        withinPortal: false, 
                                        zIndex: 10002,
                                        position: 'bottom'
                                    }}
                                     popoverProps={{
                                        withinPortal: false, 
                                        zIndex: 10002,
                                        position: 'bottom',
                                        styles: { dropdown: {  width: '350px',  maxWidth: '350px'  } }  }}
                                    styles={{ levelsGroup: { display: 'flex',  justifyContent: 'center',  width: '100%' } }}
                                />
                                <p className='gmarket-font'>종료일</p>
                                <MantineDatePicker
                                    value={endDate}
                                    onChange={setEndDate}
                                    className="mobile-date-picker"
                                    comboboxProps={{
                                        withinPortal: false, 
                                        zIndex: 10002,
                                        position: 'bottom-start'
                                    }}
                                    popoverProps={{
                                        withinPortal: false, 
                                        zIndex: 10002,
                                        position: 'bottom-start',
                                        styles: { dropdown: {  width: '350px',  maxWidth: '350px'  } }  }}
                                    styles={{ levelsGroup: { display: 'flex',  justifyContent: 'center',  width: '100%' } }}
                                />
                            </div>
                        </div>

                     <div style={{
    display: 'flex', 
    gap: '10px', 
    position: 'absolute',
    bottom: '30px',
    left: '20px',
    right: '20px'
}}>
                            <Button
                                onClick={() => setMobileFilterModalOpen(false)}
                                style={{
                                    flex: 1,
                                    height: '50px',
                                    backgroundColor: '#f4f5f6',
                                    color: '#333',
                                    borderRadius: '10px'
                                }}
                            >
                                취소
                            </Button>
                            <Button
                                onClick={handleMobileFilterSearch}
                                style={{
                                    flex: 1,
                                    height: '50px',
                                    borderRadius: '10px'
                                }}
                            >
                                찾기
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    )
}

export default PatrolList